export const Bio = {
  name: "Aditya Gangwar",
  roles: [
    "MERN Stack Developer",
    "Competitive Programmer",
    "DSA Enthusiast",
  ],
  description:
    "Final-year B.Tech. CSE Undergraduate at IIIT Kota. I am a motivated and versatile individual, always eager to take on new challenges and deliver high-quality results. With a positive attitude, growth mindset, and quick learning ability, I am an effective team player excited about contributing to the tech industry.",
  github: "https://github.com/Ad-gangwar",
  links:"https://linktr.ee/Aditya_Gangwar",
  linkedin: "https://www.linkedin.com/in/aditya-gangwar-3aa3aa257/",
  insta: "https://www.instagram.com/aditya._gangwar/",
  email: "adgangwar54@gmail.com"
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React.js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next.js",
        image:
          "https://img.icons8.com/fluent-systems-filled/200/FFFFFF/nextjs.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "https://miro.medium.com/v2/resize:fit:640/format:webp/1*Yia8fURbYbH431G0KxzCXg.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://image.pngaaa.com/779/6447779-middle.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Payload CMS",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYOaSJEHPVAGeQmenCStPygHLTqnlvoWMllw&s",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Postman",
        image:
          "https://w7.pngwing.com/pngs/28/245/png-transparent-postman-hd-logo-thumbnail.png",
      },
      {
        name: "C/C++",
        image:
          "https://e7.pngegg.com/pngimages/46/626/png-clipart-c-logo-the-c-programming-language-computer-icons-computer-programming-source-code-programming-miscellaneous-template.png",
      },
      {
        name: "Python",
        image:
          "https://www.citypng.com/public/uploads/preview/hd-python-logo-symbol-transparent-png-735811696257415dbkifcuokn.png" 
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQFep5JvaKBvrA/company-logo_200_200/company-logo_200_200/0/1719250162946/synapsis_medical_logo?e=1756339200&v=beta&t=dbkZaf0Hm_wUqahIIEhi02EfMNp6n3gMARyVxSq4vs0",
    role: "Software Developer Intern",
    company: "Synapsis Medical Technologies Inc.",
    date: "May 2025 - Present",
    desc: "Contributing to the development of web applications at Synapsis Medical by implementing frontend features and optimizing performance to enhance user experience and efficiency.",
    skills: [
      "HTML",
      "CSS",
      "TypeScript",
      "Next.js",
      "Tailwind CSS"
    ],
    doc: "",
  }, 
  {
    id: 1,
    img: "https://github.com/Ad-gangwar/Web-Relay/blob/main/Screenshot%202024-07-21%20095608.png?raw=true",
    role: "Full Stack Developer Intern",
    company: "FoodCription",
    date: "July 2024 - April 2025",
    desc: "Contributing to a health-focused initiative called FoodCription, dedicated to helping people maintain a healthy, disease-free lifestyle.",
    skills: [
      "HTML",
      "CSS",
      "TypeScript",
      "Mongo DB",
      "Express.js",
      "React.js",
      "Node.js",
      "Tailwind CSS",
      "Payload CMS",
      "Zustand"
    ],
    doc: "",
  }, 
  {
    id: 2,
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=110,fit=crop,q=95/AQEJ59B7z2sZKlrM/student_projects_hub_4k-YrDaV6rrg8hGMx5n.png",
    role: "Software Developer Intern",
    company: "Students Project Hub",
    date: "June 2024 - July 2024",
    desc: "Developed a Blood Donation website to manage blood stock data, facilitating easy donation scheduling and real-time inventory updates.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Mongoose",
      "Express JS",
      "React JS",
      "Node Js",
      "Bootstrap",
      "Redux"
    ],
    doc: "",
  }, 
];

export const education = [
  {
    id: 0,
    img: "https://github.com/Ad-gangwar/Web-Relay/blob/main/iiit%20kota.jpeg?raw=true",
    school: "Indian Institute of Information Technology, Kota",
    date: "2022 - 2026",
    grade: "8.73 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Indian Institute of Information Technology, Kota. I have completed 6 semesters and have a CGPA of 8.73. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Web Development, Database Management Systems etc.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://github.com/Ad-gangwar/Portfolio-website/blob/main/src/images/school.png?raw=true",
    school: "Mission Public Schoool, Nbj, Bly, UP",
    date: "Apr 2019 - Apr 2020",
    grade: "93.4%",
    desc: "I completed my class 12th education at Mission Public School, Bareilly, in PCM stream.",
    degree: "XII (PCM)",
  },
  {
    id: 2,
    img: "https://github.com/Ad-gangwar/Portfolio-website/blob/main/src/images/school.png?raw=true",
    school: "Mission Public Schoool, Nbj, Bly, UP",
    date: "Apr 2017 - Apr 2018",
    grade: "91.8%",
    desc: "I completed my class 10th education at Mission Public School, Bareilly.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "Legal-Ease India",
    description:
      "Legal-Ease India serves as a centralized platform, or e-market, connecting Advocates, Notaries, Mediators, Arbitrators, and Document writers with clients seamlessly. It's a one-stop solution for all your legal service needs!. It is a MERN Stack project with extremely responsive design and OTP Verification system for user authentication and security.User can request service from service provider, give ratings and feedback, modify their profile. It is a full-fledged website consisting of notification feature and payment gateway.",
    image:"https://github.com/Ad-gangwar/Web-Relay/blob/main/Screenshot%20(71).png?raw=true",
    tags: ["Mongo DB","Express JS", "React JS", "Node JS", "HTML", "CSS", "Javascript", "Cloudinary", "Bootstrap", "Stripe", "Iconify"],
    category: "web app",
    webapp: "https://legalease-india.netlify.app/",
  },
  {
    id: 1,
    title: "Medicare",
    description:
      "Welcome to our state-of-the-art Doctor Appointment System, where your health is our top priority. Our user-friendly platform is designed to seamlessly connect patients with their preferred healthcare providers, offering a convenient and efficient way to schedule appointments. Experience the ease of exploring doctor availability, receiving timely reminders, and providing valuable feedback after each visit.",
    image:
      "https://github.com/Ad-gangwar/Web-Relay/blob/main/Screenshot%20(72).png?raw=true",
    tags: ["Mongo DB","Express JS", "React JS", "Node JS", "HTML", "CSS", "Javascript", "Cloudinary", "Stripe", "Tailwind CSS", "Iconify"],
    category: "web app",
    webapp: "https://medicare-adi.netlify.app/",
  },
  {
    id: 2,
    title: "Go Food",
    description:
      "Food Delivery Website created using MERN Stack. Implemented secure user authentication and authorization using JWT (JSON Web Tokens) for enhanced data protection. Developed a dynamic shopping cart feature allowing users to add modify, and remove items seamlessly. Created a comprehensive order management system to track and display user orders efficiently.",
    image:
      "https://github.com/Ad-gangwar/Go-Food/blob/main/Screenshot%202024-01-31%20094200.png?raw=true",
    tags: ["Mongo DB","Express JS", "React JS", "Node JS", "HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Go-Food",
    webapp: "https://go-food-344.netlify.app/",
  },
  {
    id: 3,
    title: "Secrets Website",
    description:
      "Website developed using MERN Stack where people can submit their secrets anonymously and also can see others secrets as well which other peoples have shared. This website contains a login page where one can sign up by creating a new account as well as can sign in with his gmail id. This website also stores user information in form of cookies to remember users while signing in. Prioritized user security by incorporating encryption techniques and secure authentication methods.",
    image:
      "https://github.com/Ad-gangwar/Secrets/blob/main/secrets.png?raw=true",
      tags: ["React Js", "Mongoose","Express JS","HTML", "CSS", "Node JS", "Javascript"],
    category: "webapp",
    github: "https://github.com/Ad-gangwar/secrets-",
    webapp: "https://secrets-website.netlify.app/",
  },
  {
    id: 4,
    title: "Spotify Clone",
    description:
      "Engineered a full-stack Spotify clone replicating the core features of the popular music streaming platform Implemented user authentication and authorization through Passport-JWT. Enabled user to upload song, create playlist, search artists and songs.",
    image:
      "https://github.com/Ad-gangwar/Spotify-Clone/blob/main/Screenshot%202024-01-31%20095936.png?raw=true",
      tags: ["React Js", "Mongoose","Express JS","HTML", "CSS", "Node JS", "Javascript"],
    category: "webapp",
    github: "https://github.com/Ad-gangwar/Spotify-Clone",
    webapp: "https://spotify-clone-adi.netlify.app/",
  },
  {
    id: 5,
    title: "Tic-Tac-Toe Game",
    description:"This is a simple Tic Tac Toe game project made using HTML, CSS and Javascript. Game starts with the turn of X and if 3 boxes in a line are same then that player wins the game. Sound also plays for each turn and game over.",
    image:
      "https://github.com/Ad-gangwar/Tic-Tac-Toe-Game-project/blob/main/Screenshot%202024-01-31%20101126.png?raw=true",
    tags: [
      "HTML",
      "CSS", 
      "Javascript"
    ],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Tic-Tac-Toe-Game-project",
    webapp: "https://ad-gangwar.github.io/Tic-Tac-Toe-Game-project/",
  },
  {
    id: 6,
    title: "Simon Game",
    description:
      "Developed the Simon game using HTML, CSS and javascript. In this game, certain patterns are shown to player and the player has to click back the colour boxes in the same pattern. If he/she succeed in doing so, then game is transferred to another harder level and if fails, the score is displayed on the screen and game is started again.",
    image:
      "https://github.com/Ad-gangwar/Simon-game/blob/main/simon%20game.png?raw=true",
      tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Simon-game",
    webapp: "https://ad-gangwar.github.io/Simon-game/",
  },
  {
    id: 7,
    title: "Drum Kit Website",
    description:
      "This is a Drum kit website made using HTML, CSS and Javascript with user-friendly and simple interface. When one clicks on various drum icons or presses mentioned keys, chracteristic sound of various drum plays.",
    image:
      "https://github.com/Ad-gangwar/Drum-kit-Website/blob/main/Screenshot%202024-01-31%20101657.png?raw=true",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Drum-kit-Website",
    webapp: "https://ad-gangwar.github.io/Drum-kit-Website/",
  },
  {
    id: 8,
    title: "Calculator",
    description:
      "Developed a calculator using ReactJS, JavaScript, HTML, and CSS. The ReactJS component structure ensures modularity, while JavaScript manages user input, executes operations, and updates the display. HTML defines the layout, and CSS ensures a visually appealing and responsive design.",
    image:
      "https://github.com/Ad-gangwar/Calculator/blob/main/Screenshot%202024-01-31%20102609.png?raw=true",
    tags: ["React JS", "HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Calculator",
    webapp: "https://calculator-76.netlify.app/",
  },
  {
    id: 9,
    title: "Tindog Website",
    description:
      "This is a front end webpage for a website for dog where one can buy or sell dogs. This project is created using only html and css.",
    image:
      "https://github.com/Ad-gangwar/Tindog-project/blob/main/Tindog.png?raw=true",
    tags: ["HTML", "CSS"],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Tindog-project",
    webapp: "https://ad-gangwar.github.io/Tindog-project/",
  },
 
  {
    id: 10,
    title: "Keeper App",
    description:
      "It is a project for keeping notes you want to remember. One can also delete his/her notes on clicking delete button. It can also be used to keep a to-do-list. It is created using html, javascript, css and react.js.",
    image:
      "https://github.com/Ad-gangwar/Keeper_app/blob/main/Screenshot%202023-09-29%20201657.png?raw=true",
      tags: ["HTML", "CSS", "Javascript", "Express JS", "React JS"],
    category: "web app",
    github: "https://github.com/Ad-gangwar/Keeper_app",
    webapp: "https://keeper-app-84e758.netlify.app/",
  },
];
